import { render } from "./OsBasedImageSelection.vue?vue&type=template&id=4897e3bc&scoped=true"
import script from "./OsBasedImageSelection.vue?vue&type=script&lang=js"
export * from "./OsBasedImageSelection.vue?vue&type=script&lang=js"

import "./OsBasedImageSelection.vue?vue&type=style&index=0&id=4897e3bc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4897e3bc"]])

export default __exports__